import PropTypes from 'prop-types';
import VibeIcon from '../../VibeIcon/VibeIcon';
import viChevronLeft from '../../../icons/viChevronLeft';
import viChevronRight from '../../../icons/viChevronRight';
import * as color from '../../../sass/color.scss';
import './MonthNavigate.scss';

function MonthNavigate({
  text,
  onPrev = () => {},
  onNext = () => {},
}) {
  return (
    <div className="MonthNavigate">
      <VibeIcon
        icon={viChevronLeft}
        type="button"
        buttonProps={{
          size: 32,
          color: color.primary,
          borderColor: color.primary,
        }}
        tooltip="Previous"
        tooltipProps={{
          placement: 'top',
        }}
        color={color.white}
        size={20}
        onClick={onPrev}
      />

      <div className="month-text">
        {text}
      </div>

      <VibeIcon
        icon={viChevronRight}
        type="button"
        buttonProps={{
          size: 32,
          color: color.primary,
          borderColor: color.primary,
        }}
        tooltip="Next"
        tooltipProps={{
          placement: 'top',
        }}
        color={color.white}
        size={20}
        onClick={onNext}
      />
    </div>
  );
}

MonthNavigate.propTypes = {
  /** Text to show between navigation icons */
  text: PropTypes.string.isRequired,
  /** When previous month is clicked */
  onPrev: PropTypes.func,
  /** When next month is clicked */
  onNext: PropTypes.func,
};

export default MonthNavigate;
